import PlatformHelper from '@sport1/react-elements/PlatformHelper'
import { Platform } from '../'

const getPlatform = (): Platform => {
    if (PlatformHelper.getDimensions().width < 480) return Platform.MOBILE
    return Platform.DESKTOP
}

export default getPlatform
